import axiosClient from "./axiosClient";

const DEFAULT_APPROVED_TEMPLATE_PARAMS = Object.freeze({
  status: "APPROVED",
});

export async function listApprovedCampaignTemplates(
  businessId,
  params = {},
  config = {}
) {
  const response = await axiosClient.get(`templates/${businessId}`, {
    ...config,
    params: {
      ...DEFAULT_APPROVED_TEMPLATE_PARAMS,
      ...params,
    },
  });
  const data = response?.data;

  if (Array.isArray(data)) {
    return {
      success: response.status >= 200 && response.status < 300,
      templates: data,
      page: 1,
      totalPages: 1,
      totalCount: data.length,
    };
  }

  return {
    ...(data && typeof data === "object" ? data : {}),
    success:
      typeof data?.success === "boolean"
        ? data.success
        : response.status >= 200 && response.status < 300,
    templates: Array.isArray(data?.templates) ? data.templates : [],
    page: Number(data?.page) || 1,
    totalPages: Math.max(Number(data?.totalPages) || 1, 1),
    totalCount:
      Number(data?.totalCount) > 0
        ? Number(data.totalCount)
        : Array.isArray(data?.templates)
        ? data.templates.length
        : 0,
  };
}

export async function listAllApprovedCampaignTemplates(
  businessId,
  params = {},
  config = {}
) {
  const pageSize = Number(params.pageSize) > 0 ? Number(params.pageSize) : 200;
  const firstPage = await listApprovedCampaignTemplates(
    businessId,
    {
      ...params,
      page: 1,
      pageSize,
    },
    config
  );

  const firstItems = Array.isArray(firstPage?.templates)
    ? firstPage.templates
    : [];
  const totalPages = Math.max(Number(firstPage?.totalPages) || 1, 1);

  if (totalPages === 1) {
    return {
      ...firstPage,
      templates: firstItems,
    };
  }

  const allItems = [...firstItems];

  for (let page = 2; page <= totalPages; page += 1) {
    const nextPage = await listApprovedCampaignTemplates(
      businessId,
      {
        ...params,
        page,
        pageSize,
      },
      config
    );
    const nextItems = Array.isArray(nextPage?.templates)
      ? nextPage.templates
      : [];
    allItems.push(...nextItems);
  }

  return {
    ...firstPage,
    page: totalPages,
    totalPages,
    totalCount:
      Number(firstPage?.totalCount) > 0
        ? Number(firstPage.totalCount)
        : allItems.length,
    templates: allItems,
  };
}

export async function getApprovedCampaignTemplateByName(
  businessId,
  name,
  { language = "en_US", ...config } = {}
) {
  const { data } = await axiosClient.get(
    `templates/${businessId}/${encodeURIComponent(name)}`,
    {
      ...config,
      params: language ? { language } : undefined,
    }
  );
  return data?.template ?? data ?? null;
}

export async function syncApprovedCampaignTemplates(businessId, config = {}) {
  const response = await axiosClient.post(`templates/sync/${businessId}`, null, {
    ...config,
  });
  const data = response?.data;

  if (data && typeof data === "object") {
    return {
      ...data,
      success:
        typeof data.success === "boolean"
          ? data.success
          : response.status >= 200 && response.status < 300,
    };
  }

  return {
    success: response.status >= 200 && response.status < 300,
    data,
  };
}
